import giftItemQueries from '@apis/queries/giftItemQueries';
import { useQuery } from '@tanstack/react-query';

function useGiftItemNutrition(giftItemId: string) {
    return useQuery({
        ...giftItemQueries.nutritionFacts(giftItemId),
        enabled: !!giftItemId,
        retry: 1,
    });
}

export default useGiftItemNutrition;
